import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import Breadcrumb from '../../../../components/common/Breadcrumb'
import Card from '../../../../components/common/Card'
import { enrollmentInsuranceFamily } from '../../../../constant/path'
import { useCreateRelative, useGetRelative } from '../../../../services/enrollment/enrollment-query'
import { useGetUser } from '../../../../services/user/user-query'
import { useRouter } from '../../../../utils/helper'
import Image from '../../../../components/common/Image'
import Text from '../../../../components/common/Text'
import iconUser from '../../../../assets/images/icons-user-green-32-px.svg'
import { FONT_LIGHT_GRAY } from '../../../../constant/colors'
import { InputField, DatePickerField, SelectField } from '../../../../components/common/fields'
import Form from 'antd/lib/form/Form'
import { InjectedFormProps, reduxForm } from 'redux-form'
import { useCallback, useMemo } from 'react'
import FooterContent from '../../../../components/FooterContent'
import { useScreen } from '../../../../utils/responsive-helper'
import Button from '../../../../components/common/Button'
import { CreateRelative, RelativeInfo } from '../../../../services/enrollment/enrollment-types'
import { mobile } from '../../../../utils/responsive-helper'
import moment from 'moment'
import Loading from '../../../../components/common/Loading'
import { pullAt } from 'lodash'
import { useGetEnrollmentYear } from '../..'
import { useHistory } from 'react-router'

const Layout = styled.div`
  > * {
    margin-top: 24px;
  }
  text-align: center;
`

const Header = styled.div`
  justify-content: center;
  margin-top: 24px;
  margin-bottom: 24px;
`

const IconStyle = styled.div`
  padding-right: 16px;
`

const LayoutTopic = styled.div`
  display: flex;
  position: relative;
  width: 100%;
`

const CustomStyleCard = styled(Card)`
  display: flex;
  /* position: relative; */
  flex-direction: column;
  width: 100%;
  padding: 32px;
  margin-bottom: 24px;
`

const ButtonStyle = styled(Button)`
  width: 267px;
`

const ContentForm = styled.div`
  display: flex;
  text-align: start;
  flex-flow: row wrap;
`

const FlexRow = styled.div`
  display: flex;
  flex-flow: row;
  width: 100%;
  ${mobile} {
    flex-flow: column;
  }
`

const ContentField = styled.div`
  width: 100%;
`

type RelativeParams = {
  relativeInfo?: RelativeInfo
}

type RelativeProps = RelativeParams & InjectedFormProps<CreateRelative>
const enchancer = reduxForm<CreateRelative, {}, any>({
  form: 'RelativeForm',
  validate: (fields: CreateRelative) => {
    const error: Partial<CreateRelative> = {}
    if (!fields.firstname) {
      error.firstname = 'ระบุชื่อ'
    }
    if (!fields.birthday) {
      error.birthday = 'error.required'
    }
    if (!fields.title) {
      error.title = 'error.required'
    }
    if (!fields.lastname) {
      error.lastname = 'ระบุนามสกุล'
    }
    if (!fields.nationalId) {
      error.nationalId = 'ระบุเลขบัตรประชาชน'
    }
    return error
  },
})

const titleOptions = [
  {
    label: 'นาย',
    value: 'นาย',
  },
  {
    label: 'นาง',
    value: 'นาง',
  },
  {
    label: 'นางสาว',
    value: 'นางสาว',
  },
  {
    label: 'เด็กชาย',
    value: 'เด็กชาย',
  },
  {
    label: 'เด็กหญิง',
    value: 'เด็กหญิง',
  },
]

const RelativeFormArea = enchancer((props: RelativeProps) => {
  const { t } = useTranslation()
  const history = useHistory()
  const { query } = useRouter()
  const { enrollmentYear } = useGetEnrollmentYear()
  const { data: user } = useGetUser()
  const { mutate: createRelative, isLoading: isSubmitting } = useCreateRelative()

  const screen = useScreen()
  const { isMobile } = screen

  const { handleSubmit } = props

  const onSubmit = useCallback(
    (form: CreateRelative) => {
      const relative: CreateRelative = {
        title: form.title, //valueObject.title!,
        firstname: form.firstname,
        lastname: form.lastname,
        birthday: moment(form.birthday).format('YYYY-MM-DD'), //form.birthday,// date.format('YYYY-MM-DD'),//'1997-4-1',//dayjs(form.birthday).format('YYYY-MM-DD'),
        nationalId: form.nationalId || '',
        userId: user?.userId!,
        relativeTypeId: query?.relativeTypeId,
        id: query?.relativeId,
      }

      createRelative(relative, {
        onSettled: () => {
          history.goBack()
        },
      })
    },
    [createRelative, history, query?.relativeId, query?.relativeTypeId, user?.userId],
  )

  return (
    <Layout>
      {!isMobile && (
        <Breadcrumb
          overide={(paths) => {
            // paths.unshift({ label: 'Home', path: '/' })
            pullAt(paths, 3, 5, 6)
            paths[0].label = t('ปรับเปลี่ยนสวัสดิการ')
            paths[1].label = t(`ดูสวัสดิการปี ${enrollmentYear}`)
            paths[2].label = t(`สวัสดิการปี ${enrollmentYear} ของฉัน`)
            paths[3] = {
              label: t('ประกันเพิ่มเติมให้ครอบครัว'),
              path: '',
            }
            return paths
          }}
        />
      )}
      <Header>
        <Text size={28} type="Bold">
          {`เพิ่ม${query?.typeName}`}
        </Text>
      </Header>
      <LayoutTopic>
        <IconStyle>
          <Image src={iconUser} width={32} height={32} />
        </IconStyle>
        <Text size={24} type="Bold">
          {`กรอกข้อมูล${query?.typeName}`}
        </Text>
      </LayoutTopic>
      <CustomStyleCard>
        <Form>
          <ContentForm>
            <div style={{ width: isMobile ? '50%' : '33%' }}>
              <Text size={18}>ระบุคำนำหน้า (ไทย)</Text>
              <SelectField
                name="title"
                options={titleOptions}
                placeholder="ระบุคำนำหน้า"
              // value={valueObject.title}
              // onSelect={(key: string | number) => onSelect(key, 'title')}
              />
            </div>
            <FlexRow>
              <ContentField style={{ marginRight: isMobile ? 0 : 13 }}>
                <InputField name="firstname" label="ชื่อ (ไทย)" placeholder="ระบุชื่อ (ไทย)" />
              </ContentField>
              <ContentField style={{ marginLeft: isMobile ? 0 : 13 }}>
                <InputField name="lastname" label="นามสกุล (ไทย)" placeholder="ระบุนามสกุล (ไทย)" />
              </ContentField>
            </FlexRow>
            <FlexRow>
              <ContentField>
                <DatePickerField name="birthday" label="วัน/เดือน/ปีเกิด" />
              </ContentField>
            </FlexRow>
            {/* <FlexRow style={{ width: isMobile ? '100%' : '50%', paddingRight: isMobile ? 0 : 13 }}>
              <ContentField>
                <InputField
                  name="nationalId"
                  label="เลขบัตรประชาชน "
                  placeholder="เลขบัตรประชาชน"
                />
              </ContentField>
            </FlexRow> */}
          </ContentForm>
        </Form>
      </CustomStyleCard>
      <Text
        size={22}
        type="Medium"
        color={FONT_LIGHT_GRAY}
        style={{ justifyContent: 'start', display: 'flex' }}
      >
        การเพิ่มคนในครอบครัวผ่าน Belive คุณจะต้องส่งเอกสารให้กับ HR
        เพื่อเป็นการยืนยันความถูกต้องอีกครั้ง
      </Text>
      <FooterContent
        style={{
          height: 80,
          display: 'flex',
          justifyContent: isMobile ? 'center' : 'flex-end',
          alignItems: 'center',
        }}
      >
        <ButtonStyle onClick={handleSubmit(onSubmit)} disabled={isSubmitting}>
          ยืนยัน
        </ButtonStyle>
      </FooterContent>
    </Layout>
  )
})

const RelativeForm = () => {
  const { query } = useRouter()
  const { data: relativeUser, isLoading } = useGetRelative(query.relativeId)

  return (
    <div>
      <Loading loading={isLoading}>
        <RelativeFormArea
          initialValues={
            {
              ...relativeUser,
              birthday: moment(relativeUser?.birthday),
            } as Partial<CreateRelative>
          }
        />
      </Loading>
    </div>
  )
}
export default RelativeForm
